export const toAbvPercent = (storedPromille: number): number => storedPromille / 10;
export const toAbvFraction = (storedPromille: number): number => storedPromille / 1000;
